module.exports = __webpack_public_path__ + "img/delete_account.4ff7e39e.svg";